import Involve from "../components/chat/Involve";
import { ContentModel, LoginResponse } from "../models";
import { utils } from "../utils";
import { t } from "i18next";

class UserMessage {
    UserData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

    constructor() { }

    expiredCannedMessage = t("toast.expiredCannedMessage");
    signedOutMessage = t("toast.signedOutMessage");
    reConnectingMessage = t("toast.reConnectingMessage");
    signedExpireMessage = t("toast.signedExpireMessage");
    expireSessionWarnningMessage = t("toast.expireSessionWarnningMessage");

    unSentChatSingle = (count: number) => {
        return t("UnsentChat.You have") + count + t("UnsentChat.unsentChat-sendit");
    };
    unSentChatMultiple = (count: number) => {
        return t("UnsentChat.You have") + count + t("UnsentChat.unsentChat-sendthem");
    };

    duplicateIpAddress = t("toast.duplicateIpAddress");
    inValidIpAddress = t("toast.inValidIpAddress");

    saveConfirmationMsg = t("ConfirmationDialog.save-message");
    deleteConfirmationMsg = t("ConfirmationDialog.delete-message");
    saveSuccessMsg = t("toast.success-message");
    saveFailedMsg = t("toast.failed-message");
    emailExists = t("toast.emailExists");
    userExists = t("toast.userExists");
    InternetIsAvailable = t("toast.InternetIsAvailable");

    getEenvironmentWiseContent = (): ContentModel => {
        const iSmartMarkeeting: ContentModel = {
            hybridPanel: t("hybridChat.headingForiSmartMarkeeting"),
            hybridPanelDescription: t("hybridChat.contentForiSmart"),
            MonitoringPanel: t("Monitoring Panel 6er"),
            ChatTranscript: t("Chat Transcripts.i1SmartMarkeetingTitle"),
            ChatTranscriptDescription: t("Chat Transcripts.i1SmartMarkeetingContent"),
            CannedResponses: t("Canned Responses.i1SmartMarkeetingTitle"),
            CannedResponsesDescription: t("Canned Responses.i1SmartMarkeetingContent"),
            PersonalCanned: t("Personal Canned.i1SmartMarkeetingTitle"),
            PersonalCannedDescription: t("Personal Canned.i1SmartMarkeetingContent"),
            PushContent: t("Push Content.i1SmartMarkeetingTitle"),
            PushContentDescription: t("Push Content.i1SmartMarkeetingContent"),
            InvolveBtnText: t('involveComponent.InvolveFori1SmartMarketing'),
            InvolveMessage: 'Client has joined the Chat'

        };

        const LiveAdmins: ContentModel = {
            hybridPanel: t("Monitoring Panel"),
            hybridPanelDescription: t("hybridChat.content"),
            MonitoringPanel: t("Monitoring Panel 6er"),
            ChatTranscript: t("Chat Transcripts.heading"),
            ChatTranscriptDescription: t("Chat Transcripts.content"),
            CannedResponses: t("Canned Responses.heading"),
            CannedResponsesDescription: t("Canned Responses.content"),
            PersonalCanned: t("Personal Canned.heading"),
            PersonalCannedDescription: t("Personal Canned.content"),

            PushContent: t("Push Content.heading"),
            PushContentDescription: t("Push Content.content"),
            InvolveBtnText: t('involveComponent.Involve'),
            InvolveMessage: "Client Involved."

        };

        const Dep: ContentModel = {
            hybridPanel: t("Hybrid Panel"),
            hybridPanelDescription: t("hybridChat.content"),
            MonitoringPanel: t("Monitoring Panel"),
            ChatTranscript: t("Chat Transcripts.heading"),
            ChatTranscriptDescription: t("Chat Transcripts.content"),
            CannedResponses: t("Canned Responses.heading"),
            CannedResponsesDescription: t("Canned Responses.content"),
            PersonalCanned: t("Personal Canned.heading"),
            PersonalCannedDescription: t("Personal Canned.content"),

            PushContent: t("Push Content.heading"),
            PushContentDescription: t("Push Content.content"),
            InvolveBtnText: t('involveComponent.Involve'),
            InvolveMessage: "Client Involved."
        };

        if (utils.isItI1SmartMarketing() == true) {
            return iSmartMarkeeting;
        } else if (utils.isDEPCompany(this.UserData?.userLoginData?.empCompId)) {
            return Dep;
        }

        return LiveAdmins;
    };

    // HybridScreenHeading = (empCompId) => {
    //     if (utils.isItI1SmartMarketing() == true) {
    //         return t("hybridChat.headingForiSmartMarkeeting");
    //     } else if (utils.isLiveAdminsCompany(empCompId)) {
    //         return t("Monitoring Panel");
    //     }
    //     return t("Hybrid Panel");
    // };

    // MonitoringPanelScreenHeading = (empCompId) => {
    //     if (utils.isLiveAdminsCompany(empCompId)) {
    //         return t("Monitoring Panel 6er");
    //     }
    //     return t("Monitoring Panel");
    // };
}
var ResponseMessage = new UserMessage();
export { ResponseMessage };
